import * as VueGoogleMaps from 'vue2-google-maps'

export const googleMapsPlugin = VueGoogleMaps

export const googleMapsPluginOptions = {
  load: {
    key: 'AIzaSyBLjXCzb6fdYWr525YLIYZhrk9eNP6SBoY',
    libraries: 'places',
    region: 'us',
    language: 'en'
  }
}
